import styled from '@emotion/styled'

export const LoadingSpinnerWrapper = styled.div`
    position: fixed;
    right: 50%;
    top: 50%;
`
